import styled, { css } from 'styled-components'

const item = css`
  padding-left: 12px;
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`

export const Item = styled.div`
  ${item}
`

export const LinkItem = styled.a`
  ${item}
`
